import { useState } from "react"

const MIME = "application/x-chat-id"

export function chatDragProps(conversationId: string) {
  return {
    draggable: true,
    onDragStart: (event: React.DragEvent) => {
      event.dataTransfer.setData(MIME, conversationId)
      event.dataTransfer.effectAllowed = "move"
    },
  }
}

/** Drop target for chats. `onDrop` receives the dragged conversation id. */
export function useChatDropTarget(onDrop: (conversationId: string) => void) {
  const [over, setOver] = useState(false)
  const isChat = (event: React.DragEvent) => event.dataTransfer.types.includes(MIME)
  return {
    over,
    props: {
      onDragOver: (event: React.DragEvent) => {
        if (!isChat(event)) return
        event.preventDefault()
        event.dataTransfer.dropEffect = "move"
        setOver(true)
      },
      onDragLeave: (event: React.DragEvent) => {
        if (!event.currentTarget.contains(event.relatedTarget as Node | null)) setOver(false)
      },
      onDrop: (event: React.DragEvent) => {
        setOver(false)
        const id = event.dataTransfer.getData(MIME)
        if (!id) return
        event.preventDefault()
        onDrop(id)
      },
    },
  }
}
